// extracted by mini-css-extract-plugin
export default {"heading":"DatePicker_heading__NW3vp","date_picker":"DatePicker_date_picker__4DgM9","calender":"DatePicker_calender__kdsFH"};